'use strict';

angular.module('supervisorAccessReviewControllers')

.controller('Submit_SystemToReviewCtrl', ['$scope', '$state', '$stateParams', '$modal', 'systemToReviewService', function ($scope, $state, $stateParams, $modal, systemToReviewService) {

    $scope.authLogin = $stateParams.authLogin;

    $scope.thenSubmitAccessReview = function (submitResponse) {

        if (submitResponse.IsSubmitted === true) {
            // It is submitted
            $state.transitionTo('accessReview.authUser.submitted',
                                { authLogin: $scope.authLogin },
                                {
                                  reload: true,
                                  inherit: false,
                                  notify: true
                                });
            return;
        }

        // Not submitted, because some remaining systems
        var notSubmittedModal = $modal({
            scope: $scope,
            template: require('./notSubmittedModal.tpl.html'),
            placement: 'center'
        });

        $scope.hideModal = function () {
            notSubmittedModal.$promise.then(notSubmittedModal.hide);
        }

        $scope.okModal = function () {
            $scope.hideModal();

            // Reload current page
            $state.transitionTo($state.current, $stateParams, {
                reload: true,
                inherit: false,
                notify: true
            });
        }
    };

    $scope.submitAccessReview = function () {
        systemToReviewService.submitAccessReview($scope.authLogin)
                             .then($scope.thenSubmitAccessReview);
    }
}]);
